/**
 * Tipos de solicitação — restaura `erp_solicitacao.id_tipo`, o campo `tipoSS`
 * que no legado era obrigatório na criação (sgq.md §C.2) e a Onda 2 não trouxe.
 *
 * É aqui que se decide o que cada natureza de pedido exige: a ação corretiva
 * exige causa-raiz porque ISO 13485 §8.5.2 pede; o pedido de serviço não exige,
 * porque não é ação corretiva.
 */

import { RequestType, queryKeys, requestTypesApi } from '@/lib/api';
import {
  SupportTypeAdmin,
  type SupportTypeFlag,
} from '@/components/sgq/support-type-admin';

const FLAGS: readonly SupportTypeFlag<RequestType>[] = [
  {
    key: 'requiresRootCause',
    label: 'Exige causa-raiz',
    description:
      'Só pode ser aberta a partir do Ishikawa de uma não-conformidade. É o que separa a ação corretiva do pedido avulso.',
  },
  {
    key: 'requiresFullPlan',
    label: 'Exige o plano 5W2H completo',
    description:
      'Cobra "por quê" e "como" no preenchimento. Desligue para pedidos de trabalho, em que essas perguntas não têm resposta útil.',
  },
  {
    key: 'preventiveDefault',
    label: 'Nasce como preventiva',
    description: 'Marca a solicitação como ação preventiva por padrão — ISO 13485 §8.5.3.',
  },
];

export function RequestTypesPage() {
  return (
    <SupportTypeAdmin<RequestType>
      title="Tipos de solicitação"
      description="Cada tipo define o que a solicitação vai exigir de quem a abre. A solicitação avulsa existe porque há tipo que dispensa causa-raiz."
      noun="tipo de solicitação"
      usageNoun="solicitação"
      breadcrumbLabel="Tipos de solicitação"
      queryKey={queryKeys.requestTypes.all({ includeInactive: true })}
      flags={FLAGS}
      api={requestTypesApi as never}
    />
  );
}
